'use strict';

var React = require('react');

module.exports = React.createClass({
	displayName: 'SVTPlayer',

	render: function() {
		var model = this.props.model;

		if (!model) {
			return false;
		}

		if (!model.embedHref) {
			return false;
		}

		// should we add a default bgimage (model.picture type large) ?
		return(
			<div className="svtse_video">
				<iframe className="svtse_video__player" src={model.embedHref} frameBorder="0" scrolling="no"></iframe>
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/elements/SVTPlayer.jsx
 **/